<template>
  <CFooter :fixed="false">
    <div>
      <span class="mr-1">Powered by</span>
      <a href="https:/outsmartis.com" target="_blank">OUTSMARTIS</a>
    </div>
    <div class="ml-auto">
      <a class="mr-4" href="/#/privacypolicy" target="_blank">{{ $t('privacyPolicy') }}</a>
      <a href="mailto:global@outsmartis.com" target="_blank">{{ $t('support') }}</a>
    </div>
  </CFooter>
</template>

<script>
export default {
  name: 'TheFooter'
}
</script>
